import React from "react";
import Image from "./Image";
import Mark from "../../../common/components/mark/Mark";

/* eslint-disable react/prop-types */

export function HotspotImages(base) {
  return {
    getRenderTemplate: function (state, props) {
      let marks = props.marks || {};
      let box_id = props.id;
      let markElements = Object.keys(marks).map((e) => {
        let position = marks[e].value.split(",");
        let title = marks[e].title;
        let color = marks[e].color;
        let isPopUp = marks[e].connectMode === "popup";
        let isVisor = true;
        return (
          <div
            key={e}
            style={{
              position: "absolute",
              top: position[0] + "%",
              left: position[1] + "%",
              width: "24px",
              height: "26px",
            }}
          >
            <Mark
              color={color}
              idKey={e}
              title={title}
              isPopUp={isPopUp}
              isVisor={isVisor}
              markConnection={marks[e].connection}
              markValue={marks[e].value}
              boxID={box_id}
              onMarkClicked={props.onMarkClicked}
            />
          </div>
        );
      });
      return <Image markElements={markElements} props={props} state={state} />;
    },
  };
}
/* eslint-enable react/prop-types */
